import React from 'react';
import { Box, Typography, Stack, LinearProgress, Chip } from '@mui/material';
import SkeletonBlock from '../ui/SkeletonBlock';

export default function ShortAbsenceStats({ stats, loading }) {
  if (loading) return <SkeletonBlock lines={2} />;
  if (!stats) return null;

  const {
    totalApprovedHours = 0,
    totalPendingHours = 0,
    monthlyLimitHours = 8,
    approvedRequestCount = 0,
    pendingRequestCount = 0,
    monthName = '',
    year = new Date().getFullYear(),
    equivalentWorkDays = 0,
    isOverLimit = false
  } = stats;

  const totalUsed = totalApprovedHours + totalPendingHours;
  const progressPercent = Math.min((totalUsed / monthlyLimitHours) * 100, 100);

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {monthName} {year} Summary
      </Typography>

      <Stack direction="row" spacing={3} alignItems="center" sx={{ mb: 2 }}>
        <Box>
          <Typography variant="body2" color="text.secondary">Approved</Typography>
          <Typography variant="h5" color="success.main">
            {totalApprovedHours}h
          </Typography>
          <Typography variant="caption" color="text.secondary">
            ({approvedRequestCount} requests)
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">Pending</Typography>
          <Typography variant="h5" color="warning.main">
            {totalPendingHours}h
          </Typography>
          <Typography variant="caption" color="text.secondary">
            ({pendingRequestCount} requests)
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">Equivalent Days</Typography>
          <Typography variant="h5">
            {equivalentWorkDays}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            (8h = 1 day)
          </Typography>
        </Box>
      </Stack>

      <Box sx={{ mb: 1 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="body2">
            Monthly Usage: {totalUsed}h / {monthlyLimitHours}h
          </Typography>
          {isOverLimit && (
            <Chip label="Over Limit" color="warning" size="small" />
          )}
        </Stack>
        <LinearProgress
          variant="determinate"
          value={progressPercent}
          color={isOverLimit ? 'warning' : 'primary'}
          sx={{ height: 8, borderRadius: 1, mt: 0.5 }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        Note: Monthly limit is a soft limit for tracking purposes. Requests can still be submitted and approved.
      </Typography>
    </Box>
  );
}

